import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function getToken(forceRefresh = false) {
  const currentUser = getAuth().currentUser;
  if (!currentUser) return null;
  return currentUser.getIdToken(forceRefresh);
}

async function buildHeaders(forceRefresh = false) {
  const headers = { "Content-Type": "application/json" };
  const token = await getToken(forceRefresh);
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

const axiosInstance = axios.create({ baseURL: API_BASE_URL || "" });

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retried &&
      getAuth().currentUser
    ) {
      originalRequest._retried = true;
      const headers = await buildHeaders(true);
      originalRequest.headers.Authorization = headers.Authorization;
      return axiosInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export async function authenticatedFetch(url, options = {}) {
  const fullUrl = url.startsWith("http") ? url : `${API_BASE_URL}${url}`;
  const headers = await buildHeaders();
  const response = await fetch(fullUrl, { ...options, headers: { ...headers, ...options.headers } });

  if (response.status === 401 && getAuth().currentUser) {
    const refreshedHeaders = await buildHeaders(true);
    const retryResponse = await fetch(fullUrl, {
      ...options,
      headers: { ...refreshedHeaders, ...options.headers },
    });
    return retryResponse;
  }
  return response;
}

export async function authenticatedAxios(method, url, data = null, config = {}) {
  const headers = await buildHeaders();
  return axiosInstance({
    method,
    url,
    data,
    headers: { ...headers, ...config.headers },
    ...config,
  });
}

export { axiosInstance, buildHeaders, API_BASE_URL };
